import styles from '@/components/template/footer/FooterAddress/FooterAddress.module.scss'
import cmsContactBlockSettingsObject from '@/entities/cmsContactBlockSettings/interface'
import React from 'react'

interface Props {
  contactBlockSettings: cmsContactBlockSettingsObject
}

const FooterAddress = ({ contactBlockSettings }: Props) => {
  const { phonePrefix, phone, phone2Prefix, phone2, email } = contactBlockSettings
  const phoneLink = !phone ? phone : 'tel:' + phone.replace('(0)', '').split(' ').join('')
  const phone2Link = !phone2 ? phone2 : 'tel:' + phone2.replace('(0)', '').split(' ').join('')

  return (
    <div className={styles.root}>
      <p className="mb-4">
        <span className={styles.title}>SURPRISE KULTOUR AG</span>
        Rudolfstrasse 37
        <br />
        8400 Winterthur
      </p>
      <div className="mb-4">
        <div className={'mb-1'}>
          {phonePrefix && <span className={styles.country}>{phonePrefix} </span>}
          <a href={phoneLink} data-tr-click="footer:contact_phone:click">
            {phone}
          </a>
        </div>
        {phone2 && (
          <div className={'mb-1'}>
            {phone2Prefix && <span className={styles.country}>{phone2Prefix} </span>}
            <a href={phone2Link} data-tr-click="footer:contact_phone:click">
              {phone2}
            </a>
          </div>
        )}

        <a href={`mailto:${email}`} data-tr-click="footer:contact_email:click">
          {email}
        </a>
      </div>
    </div>
  )
}

export default FooterAddress
